import { ButtonPrimary } from "components/Atoms/Button";
import React, { useCallback } from "react";
import { routes } from "utilities/routing/generatedRoutes";
import { useOpenSidePanel } from "../SidePanel";
import { DetailSidePanel } from "../DetailSidePanel";
import { VenueSidePanelDetails } from "./VenueSidePanelDetails";

export interface VenueSidePanelProps {
  venueId: number
  trigger: JSX.Element
  fallbackIfNoPermission?: JSX.Element
  onOpen?: () => void
}

export const VenueSidePanel = (props: VenueSidePanelProps) => {
  if (!site.permissions.addressBook.canAccess) {
    return props.fallbackIfNoPermission || props.trigger;
  }

  return <DetailSidePanel
    apiCall={() => window.CoreApi.Venue.GetVenue(props.venueId)}
    apiKey="venue"
    entityId={props.venueId}
    title={site.currentEnvironment.functionGroups.venue.singular}
    footerContent={<>
      <ButtonPrimary href={routes.company_Detail(props.venueId).absolute} label={RESX.Buttons.DetailView} />
    </>}
    onOpen={props.onOpen}
    trigger={props.trigger}
  >
    {(venue, refetch) => <VenueSidePanelDetails
      venue={venue}
      refetch={refetch}
    />}
  </DetailSidePanel>;
};

export const useOpenVenueSidePanel = () => {
  const openSidePanel = useOpenSidePanel();

  const openVenueSidePanel = useCallback((venueId: number) => {
    openSidePanel(<DetailSidePanel<server.dto.Venue>
      apiCall={() => window.CoreApi.Venue.GetVenue(venueId)}
      apiKey="venue"
      entityId={venueId}
      title={site.currentEnvironment.functionGroups.venue.singular}
      footerContent={
        <ButtonPrimary href={routes.company_Detail(venueId).absolute} label={RESX.Buttons.DetailView} />
      }
      skipSidePanelBase
    >
      {(venue, refetch) => <VenueSidePanelDetails
        venue={venue}
        refetch={refetch}
      />}
    </DetailSidePanel>, `venue-side-${venueId}`);
  }, [openSidePanel]);

  return openVenueSidePanel;
}